<template>
  <article class="source-document">
    <div class="source-document__actions mb-2">
      <a
        class="btn btn-primary"
        :href="source.url"
        :download="source.fileName"
      >
        PDF'i indir
      </a>
      <span class="text-muted">
        Orijinal PDF belgesi
      </span>
    </div>

    <object
      class="source-document__pdf"
      :data="source.url"
      type="application/pdf"
    >
      <p>
        Tarayıcınız PDF önizlemesini desteklemiyor.
        <a
          :href="source.url"
          :download="source.fileName"
        >Belgeyi indirin.</a>
      </p>
    </object>

  </article>
</template>

<script>
/* eslint-disable global-require */
const SOURCE_FILES = Object.freeze({
  'kvkk-law': {
    url: require('../../../../legaldocs/KİŞİSEL VERİLERİ KORUMA KANUNU.pdf'),
    fileName: 'KİŞİSEL VERİLERİ KORUMA KANUNU.pdf',
  },
  'erasure-regulation': {
    url: require('../../../../legaldocs/KİŞİSEL VERİLERİN SİLİNMESİ YÖNETMELİK.pdf'),
    fileName: 'KİŞİSEL VERİLERİN SİLİNMESİ YÖNETMELİK.pdf',
  },
  'controller-application-communique': {
    url: require('../../../../legaldocs/VERİ SORUMLUSUNA BAŞVURU TEBLİĞ.pdf'),
    fileName: 'VERİ SORUMLUSUNA BAŞVURU TEBLİĞ.pdf',
  },
})

export default {
  name: 'SourceDocument',
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  computed: {
    source() {
      return SOURCE_FILES[this.document.key]
    },
  },
}
</script>

<style scoped lang="scss">
.source-document__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.source-document__pdf {
  display: block;
  width: 100%;
  min-height: 70vh;
  border: 1px solid rgba(128, 128, 128, 0.35);
  border-radius: 0.357rem;
  background: #fff;
}

</style>
